const NoPage = () => {
  return <h1 class="content-container">404</h1>;
};

export default NoPage;
